import { CSSObject, MantineSize } from "@mantine/core";

export const fontSizes: Record<MantineSize, number> = {
  xs: 12,
  sm: 14,
  md: 16,
  lg: 18,
  xl: 24,
};

export type TextSizes =
  | "title-1"
  | "title-2"
  | "title-3"
  | "headline"
  | "sub-headline"
  | "body"
  | "body-small"
  | "caption"
  | "button-large"
  | "button-medium"
  | "button-small";

export interface Style {
  size: MantineSize | number;
  weight?: number | string;
  style: CSSObject;
}

type StyleMap = Record<TextSizes, Style>;

export const textStyleMapping: StyleMap = {
  "title-1": {
    size: 60,
    weight: 700,
    style: {
      fontSize: 60,
      lineHeight: 1.2,
      letterSpacing: "-0.05em",
    },
  },
  "title-2": {
    size: 48,
    weight: 800,
    style: {
      fontSize: 34,
      lineHeight: 1.17,
    },
  },
  "title-3": {
    size: 34,
    weight: 800,
    style: {
      fontSize: 34,
      lineHeight: 1.17,
    },
  },
  headline: {
    size: "xl",
    weight: 800,
    style: {
      fontSize: fontSizes.xl,
      lineHeight: 1.32,
      letterSpacing: "0.01em",
    },
  },
  "sub-headline": {
    size: "lg",
    weight: 700,
    style: {
      fontSize: fontSizes.lg,
      lineHeight: 1.35,
      letterSpacing: "0.01em",
    },
  },
  body: {
    size: "md",
    style: {
      fontSize: fontSizes.md,
      lineHeight: 1.16,
    },
  },
  "body-small": {
    size: "sm",
    style: {
      fontSize: fontSizes.sm,
      lineHeight: 1.16,
    },
  },
  caption: {
    size: "xs",
    style: {
      fontSize: fontSizes.xs,
      lineHeight: 1.3,
      letterSpacing: "0.03em",
    },
  },
  "button-large": {
    size: "md",
    weight: 700,
    style: {
      lineHeight: 1.5,
      fontSize: fontSizes.md,
      letterSpacing: "0.03em",
    },
  },
  "button-medium": {
    size: "sm",
    weight: 700,
    style: {
      fontSize: fontSizes.sm,
      lineHeight: 1.71,
      letterSpacing: "0.02em",
    },
  },
  "button-small": {
    size: "xs",
    weight: 700,
    style: {
      fontSize: fontSizes.xs,
      lineHeight: 1.3,
      letterSpacing: "0.04em",
    },
  },
};
